// extracted by mini-css-extract-plugin
module.exports = {"themeWrapper":"purchase-pass_themeWrapper__9z2FW","deco":"purchase-pass_deco__WPSqS"};